import React, { useState, useEffect } from "react";
import { Button, Form, FormGroup } from "react-bootstrap";
import Modal from "../common/components/ThemedModal";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { updateUserThunk, getUserThunk } from "../../store/thunks/authThunk";
import { useAppDispatch } from "../../store/hooks";

interface TermsAndConditionsModalProps {
	show: boolean;
	onHide: () => void;
}

const TermsAndConditionsModal: React.FC<TermsAndConditionsModalProps> = ({
	show,
	onHide,
}) => {
	const dispatch = useAppDispatch();
	const { user } = useSelector((state: RootState) => state.user);

	const [agreeToTerms, setAgreeToTerms] = useState<boolean>(
		user?.agreeToTerms || false,
	);
	const [agreeToMarketing, setAgreeToMarketing] = useState<boolean>(
		user?.agreeToMarketing || false,
	);

	useEffect(() => {
		if (user) {
			setAgreeToTerms(user.agreeToTerms || false);
			setAgreeToMarketing(user.agreeToMarketing || false);
		}
	}, [user]);

	const handleTermsChange = async (checked: boolean) => {
		if (user) {
			setAgreeToTerms(checked);
			try {
				dispatch(updateUserThunk({ _id: user._id, agreeToTerms: checked }));
				// dispatch(getUserThunk());
			} catch (error) {
				console.error("Error updating terms agreement:", error);
				alert("Error updating terms agreement. Please try again.");
			}
		}
	};

	const handleMarketingChange = async (checked: boolean) => {
		if (user) {
			setAgreeToMarketing(checked);
			try {
				await dispatch(
					updateUserThunk({
						id: user._id,
						userData: { agreeToMarketing: checked },
					}),
				);
				// dispatch(getUserThunk());
			} catch (error) {
				console.error("Error updating marketing agreement:", error);
				alert("Error updating marketing agreement. Please try again.");
			}
		}
	};

	const handleContinue = () => {
		if (agreeToTerms) {
			onHide();
		} else {
			alert("You must agree to the terms and conditions to continue.");
		}
	};

	return (
		<Modal
			show={show}
			onHide={onHide}
			backdrop="static"
			keyboard={false}
			centered
		>
			<Modal.Header>
				<Modal.Title>Terms and Conditions</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Form>
					{/* Terms Agreement Checkbox */}
					<FormGroup className="mb-3 text-light">
						<Form.Check
							type="checkbox"
							id="agreeToTerms"
							label={
								<>
									I agree to the{" "}
									<a
										href="/termsandconditions"
										target="_blank"
										rel="noopener noreferrer"
										className="text-primary"
									>
										terms and conditions
									</a>{" "}
									(required)
								</>
							}
							checked={agreeToTerms}
							onChange={(e) => handleTermsChange(e.target.checked)}
							className="text-light"
							required
						/>
					</FormGroup>

					{/* Marketing Agreement Checkbox */}
					<FormGroup className="mb-3 text-light">
						<Form.Check
							type="checkbox"
							id="agreeToMarketing"
							label="I DO WANT to subscribe to marketing updates, competitions team updates & pro tips"
							checked={agreeToMarketing}
							onChange={(e) => handleMarketingChange(e.target.checked)}
							className="text-light"
						/>
					</FormGroup>
				</Form>
			</Modal.Body>
			<Modal.Footer>
				<Button
					variant="primary"
					onClick={handleContinue}
					disabled={!agreeToTerms}
				>
					Continue
				</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default TermsAndConditionsModal;
